// extracted by mini-css-extract-plugin
export default {"box-field":"create-notes_box-field__S2AKZ"};